/**
 * Admin Login Form
 * Section 6.1 - Authentication UI
 */

import { useState } from 'react';
import { login } from '../utils/adminAuth';
import './LoginForm.css';

function LoginForm({ onLoginSuccess }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const result = await login(password);

    if (result.success) {
      onLoginSuccess();
    } else {
      setError(result.error || 'Login failed');
      setPassword('');
    }

    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>Admin Panel</h1>
          <p>NorCal Mobile Oil Change</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              autoFocus
              required
            />
          </div>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={isLoading || !password}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="login-footer">
          <p>Protected area. Authorized personnel only.</p>
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
